import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  @media screen and (min-width: 768px) {
    background: white;
  }
  .main-div {
    background-color: white;
    border-radius: 20px;
    padding-bottom: 20px;
    /* @media screen and (min-width: 768px) {
      height: calc(-100px + 100vh);
    } */
  }

  .btn-dark {
    background-color: #142c1f;
    color: white;
    border-radius: 8px;
    padding: 12px;
    border: none;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
  }

  .btn-dark:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
  }

  .w-full {
    width: 100%;
  }

  .mt-8 {
    /* margin-top: 32px; */
  }
  .payment-methods {
    img {
      width: 100%;
    }
  }
`;

export const ContentSection = styled.div`
  padding: 20px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

export const ProfileGoalSection = styled.div`
  display: flex;
  padding: 16px 0px;
  border-radius: 12px;
  gap: 10px;

  img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    margin-top: 5px;
    border-radius: 15px;
  }

  .goal-info {
    flex: 1;
    .goal-label {
      font-size: 16px;
      color: #44554c;
      margin-bottom: 4px;
    }

    .goal-value {
      font-size: 14px;
      color: #142c1f;
      margin-bottom: 8px;
    }

    .goal-description {
      font-size: 14px;
      color: #44554c;
      line-height: 1.4;
    }
  }
`;

export const PaymentToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  gap: 20px;

  .toggle-option {
    font-size: 14px;
    color: #1c9d87;
    padding: 8px 12px;
  }

  .toggle-option.active {
    color: #1c9d87;
    font-weight: 600;
  }

  /* Ant Design Switch customization */
  .payment-switch {
    margin: 0 12px;

    .ant-switch-checked {
      background-color: #1c9d87;
    }
  }
`;

export const PaymentBreakdown = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  .payment-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #e2e4e9;

    &:last-child {
      border-bottom: none;
    }

    .payment-info {
      .payment-title {
        font-size: 16px;
        color: #142c1f;
        margin-bottom: 4px;
      }

      .payment-subtitle {
        color: #71807a;
      }
    }

    .payment-amount {
      font-size: 16px;
      color: #44554c;
    }
    .primary {
      color: #359d87;
    }
  }
`;
export const HeaderWrapper = styled.div`
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border-radius: 8px;
  opacity: 1;
  p {
    font-weight: 500;
  }
`;
export const PaymentMethods = styled.div`
  margin-bottom: 20px;
  .payment-info-text {
    color: #44554c;
    margin-top: -20px;
    padding-left: 10px;
  }
`;

export const RegistrationForm = styled.div`
  .form-section-title {
    font-size: 18px;
    color: #142c1f;
    margin-bottom: 8px;
  }

  .form-description {
    font-size: 14px;
    color: #44554c;
    margin-bottom: 24px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;

  label {
    color: #142c1f;
    margin-bottom: 16px;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
  }
`;

export const Input = styled.input`
  width: ${(props) => (props.width ? props.width : "100%")};
  padding: 12px 16px;
  border: 2px solid ${(props) => (props.hasError ? "#ff4d4f" : "#e2e4e9")};
  border-radius: 10px;
  font-size: 16px;
  color: #142c1f;

  &:focus {
    outline: none;
    border-color: #1c9d87;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;

  label {
    font-size: 14px;
    color: #44554c;
    margin-left: 12px;
    line-height: 1.4;
  }
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${(props) => (props.checked ? "#1c9d87" : "#e2e4e9")};
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  margin-top: 2px;

  &:after {
    content: "";
    position: absolute;
    display: ${(props) => (props.checked ? "block" : "none")};
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid #1c9d87;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
export const Divider = styled.div`
  width: "100%";
  height: 1px;
  background-color: #e2e4e9;
  margin: 10px 0px;
`;
export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;
`;

// Add these styled components to your existing styles

// Responsive view containers
export const MobileView = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`;

export const DesktopView = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block;
  }
`;

// Desktop styled components matching the image
export const DesktopContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 30px;
`;

export const DesktopHeader = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

export const DesktopTitle = styled.h3`
  font-size: 20px;
  color: #142c1f;
  margin-bottom: 10px;
`;

export const DesktopSubtitle = styled.p`
  font-size: 16px;
  color: #44554c;
  margin: 0;
`;

export const PaymentToggleDesktop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin: ${(props) => (props.margin ? props.margin : "20px 0")};

  span {
    font-size: 16px;
  }

  .payment-switch-desktop {
    background-color: #2ecf96;

    &.ant-switch-checked {
      background-color: #2ecf96;
    }
  }
`;

export const DesktopSubscriptionCard = styled.div`
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
  border: 2px solid #e2e4e9;
`;

export const DesktopCardTitle = styled.h3`
  font-size: 20px;
  color: ${(props) => (props.color ? props.color : "#142c1f")};
  margin: 0 0 5px 0;
`;

export const SubscriptionItem = styled.div`
  display: flex;
  padding: 15px 0;
`;

export const SubscriptionLogo = styled.div`
  margin-right: 15px;

  .pro-box {
    background-color: #142c1f;
    color: white;
    width: 89px;
    height: 89px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-radius: 8px;
    font-size: 18px;
  }

  .kre-box {
    background-color: #a5b5af;
    color: white;
    width: 89px;
    height: 89px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-radius: 5px;
  }
`;

export const SubscriptionDetails = styled.div`
  flex: 1;
  .subscription-name {
    font-size: 18px;
    color: #142c1f;
  }

  .subscription-description {
    color: #a5b5af;
    margin: 5px 0;
  }

  .subscription-duration {
    color: #44554c;
  }
`;
export const SubscriptionPriceHorizontol = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  .price {
    font-weight: 500;
    font-size: 18px;
    color: #44554c;
  }

  .discount {
    padding: 5px 10px;
    background: #f5f5f5;
    border-radius: 8px;
    color: #1c9d87;
  }

  .frequency {
    font-size: 14px;
    color: #44554c;
    text-align: center;
    margin-top: 5px;
  }
`;
export const SubscriptionPrice = styled.div`
  text-align: right;

  .price {
    font-weight: 500;
    font-size: 18px;
    color: #44554c;
    padding: 5px 10px;
    background: #f5f5f5;
    border-radius: 8px;
  }

  .discount {
    color: #2ecf96;
  }

  .frequency {
    font-size: 14px;
    color: #44554c;
    text-align: center;
    margin-top: 5px;
  }
`;

export const TotalPrice = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  padding-left: 20px;
  padding-right: 20px;

  .total-label {
    font-weight: 500;
    font-size: 16px;
    color: #333;
  }

  .total-amount {
    font-weight: 600;
    font-size: 18px;
    color: #1c9d87;
  }

  .tax-note {
    font-size: 12px;
    color: #888;
    align-self: flex-end;
    margin-left: 5px;
  }
`;

export const DesktopAddressSection = styled.div`
  border-radius: 10px;
  padding: 0;
  margin-bottom: 30px;
  border: 2px solid #e2e4e9;
  overflow: hidden;
`;

export const SectionDropdown = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;

  .dropdown-header {
    color: #142c1f;
    font-size: 16px;
  }

  .dropdown-icon {
    color: #2ecf96;
    font-size: 12px;
  }
`;

export const AddressFormRow = styled.div`
  padding: 10px 20px;
`;

export const AddressInput = styled.input`
  width: ${(props) => (props.width ? props.width : "100%")};
  padding: 12px 15px;
  border: 1.5px solid ${(props) => (props.hasError ? "#ff4d4f" : "#e2e4e9")};
  border-radius: 10px;
  font-size: 16px;
  color: #2c2c2c;

  &:focus {
    outline: none;
    border-color: #2ecf96;
  }
`;

export const DesktopAgreementSection = styled.div`
  margin-bottom: 30px;
`;

export const AgreementCheckbox = styled.div`
  display: flex;
  margin-bottom: 15px;

  .desktop-checkbox {
    margin-right: 10px;
    margin-top: 3px;
  }

  .agreement-text {
    color: #44554c;
  }
`;

export const LinkText = styled.a`
  color: #2ecf96;
  text-decoration: underline;
  cursor: pointer;
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 16px;
  background-color: white;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23999%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20class%3D%22feather%20feather-chevron-down%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
`;

export const CountrySelectWrapper = styled.div`
  width: 100%; // Make the wrapper fill available space

  /* Increase border width for Ant Design select */
  :where(.css-dev-only-do-not-override-7p2amn).ant-select-outlined:not(
      .ant-select-customize-input
    )
    .ant-select-selector,
  .ant-select-selector {
    border-width: 1.5px !important; /* Increase from 1px to 2px */
    border-color: ${(props) =>
      props.hasError ? "#ff4d4f" : "#e2e4e9"} !important;
    border-radius: 10px !important;
    min-height: 45px !important;
  }

  /* Target the opened state to maintain thicker border */
  :where(
      .css-dev-only-do-not-override-7p2amn
    ).ant-select-outlined.ant-select-focused:not(.ant-select-disabled):not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    border-width: 2px !important;
    border-color: #2ecf96 !important;
    box-shadow: none !important;
  }

  /* Ensure consistent styling for the ant-select components */
  .ant-select-selection-search {
    display: flex;
    align-items: center;
  }

  .ant-select-selection-placeholder,
  .ant-select-selection-item {
    padding: 8px 0;
    font-size: 16px;
  }

  .country-select__control {
    width: 100%; // Make the control fill the wrapper
    padding: 12px 16px; // Increased padding
    min-height: 50px; // Set minimum height
    border: 2px solid ${(props) => (props.hasError ? "#ff4d4f" : "#e2e4e9")};
    border-radius: 10px;
    box-shadow: none;

    &:hover {
      border-color: ${(props) => (props.hasError ? "#ff4d4f" : "#e2e4e9")};
    }

    &--is-focused {
      /* border-color: #2ecf96 !important; */
      box-shadow: none;
    }
  }

  .country-select__placeholder {
    font-size: 16px; // Larger placeholder text
  }

  .country-select__menu {
    width: 100%; // Make dropdown menu the same width as the control
    z-index: 1000; // Ensure the dropdown appears above other elements
  }

  .country-select__option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px; // Increase padding for dropdown items
    font-size: 16px; // Larger font size for options
  }

  .country-select__single-value {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px; // Larger font size for selected value
  }

  .country-select__indicator {
    padding: 0 12px; // Increase padding for the dropdown indicators
  }

  .country-select__value-container {
    padding: 2px 12px; // Adjust value container padding
  }
`;
